import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'BILL_SCOUT_DIALOG';

export const showBillScoutDialog = createAction(
  rootUiActions.createDialog.toString(),
  (institutionLoginId, accountClientIds) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    id: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      institutionLoginId,
      accountClientIds,
    }),
  }),
);
